import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

const textMatcher = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

export const AllManufacturer = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'TextBoxRender',
    // cellRenderer: 'GenericCodeTextBox',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const labererAndQuarterGrid = [
  {
    headerName: 'Mfg ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_320,
    cellClass: 'frr-ellipsis-text',
    columnSpan: 3,
    cellRenderer: 'TextBoxRender',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

const quarters = [];
// Get current year and quarter
const now = new Date();
const currentYear = now.getFullYear();
const currentQuarter = Math.floor((now.getMonth() + 3) / 3);

// Loop through each year from 1991 to current year
for (let year = 1991; year <= currentYear; year += 1) {
  // Loop through each quarter in the year
  for (let quarter = 1; quarter <= 4; quarter += 1) {
    // If it's the current year, only add quarters up to the current quarter
    if (year === currentYear && quarter > currentQuarter) {
      break;
    }
    quarters.push(`${quarter}Q${year}`);
  }
}
export const getAllLabererCol = () => {
  let columnList = [];
  columnList = [
    {
      headerName: 'Mfg ID',
      field: 'mfgId',
      editable: false,
      suppressMenu: false,
      sortable: true,
      minWidth: Styles.Width_110,
      cellRenderer: 'GenericCodeTextBox',
      cellStyle: { borderRightColor: Styles.BorderColor },
      cellEditorParams: {
        maxLength: 5,
        custWidth: '135px',
      },
      custClass: 'tbill-rate-editable-input',
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    {
      headerName: 'Manufacturer Name',
      field: 'mfgName',
      editable: false,
      suppressMenu: false,
      sortable: true,
      minWidth: Styles.Width_250,
      // columnSpan: 3,
      wrapText: true,
      cellRenderer: 'TextBoxRender',
      cellClass: 'frr-ellipsis-text',
      // columnSpan: 3,
      cellStyle: { borderRightColor: Styles.BorderColor },
      cellEditorParams: {
        maxLength: 5,
        custWidth: '135px',
      },
      custClass: 'tbill-rate-editable-input',
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
      },
    },
    // {
    //   headerName: '',
    //   field: '',
    //   removeColumn: true,
    //   minWidth: 1,
    //   resizable: false,
    //   editable: false,
    // },

    // {
    //   headerName: '',
    //   field: '',
    //   removeColumn: true,
    //   minWidth: 1,
    //   resizable: false,
    //   editable: false,
    // },
  ];
  for (let index = 0; index < quarters.length; index += 1) {
    const element = quarters[index];
    columnList.push({
      headerName: element,
      field: element,
      editable: false,
      suppressMenu: false,
      sortable: true,
      minWidth: Styles.Width_150,
      isTextColorRed: true,
      cellRenderer,
      printPrefixValue: '$',
      // valueFormatter: dollarFormatter,
      cellEditorParams: {
        maxLength: 5,
        custWidth: '135px',
      },
      cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
      custClass: 'tbill-rate-editable-input',
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'startsWith',
        suppressAndOrCondition: true,
        buttons: ['reset'],
        refreshValuesOnOpen: true,
        textMatcher,
      },
    });
  }
  columnList.push({
    headerName: 'Totals',
    field: 'totals',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    isTextColorRed: true,
    cellRenderer,
    printPrefixValue: '$',
    // valueFormatter: dollarFormatter,
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    custClass: 'tbill-rate-editable-input',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
  });
  return columnList;
};

export const getDefaultQtrOutstanding = () => {
  const obj = quarters.reduce((acc, value) => {
    acc[value] = '0.00';
    return acc;
  }, {});
  return obj;
};
